(ns hypnos.backoffice.panel.patients
  "The patients (list) panel."
  (:require [hypnos.backoffice.tile.patients :as patients]
            [hypnos.graphql.queries :as queries]
            [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]
            [reagent.core :as reagent]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- search-field
  [query]
  (let [state (reagent/atom query)]
    (fn []
      [:div.level-item
       [:div.field.has-addons
        [:div.control
         [:button.button.is-info
          {:type     :submit
           :on-click (fn [_]
                       (rf/dispatch-sync [:backoffice/set-patients-query @state]))}
          [:span.icon [:i.mdi.mdi-magnify]]]]
        [:div.control
         [:input.input
          {:type         :text
           :placeholder  "Search ..."
           :value        @state
           :on-key-press (fn [e]
                           (let [key-code (or (.-which e) (.-keyCode e))]
                             (when (= key-code 13)
                               (rf/dispatch-sync [:backoffice/set-patients-query @state]))))
           :on-change    (fn [e]
                           (let [new-value (-> e .-target .-value)]
                            (reset! state new-value)))}]]
        [:div.control
         [:button.button.is-info
          {:type     :submit
           :disabled (nil? @state)
           :on-click (fn [_]
                       (reset! state nil)
                       (rf/dispatch-sync [:backoffice/set-patients-query nil]))}
          [:span.icon [:i.mdi.mdi-close]]]]]])))

(defn- pagination
  [{:keys [offset limit total filter query]}]
  (when (< 0 total)
    (let [org-ids      (mapv str (:organization-ids filter))
          page-count   (inc (quot (dec total) limit))
          current-page (inc (quot (dec offset) limit))
          delta        2
          left         (- current-page delta 1)
          right        (+ current-page delta 1)]
      [:div.level
       [:div.level-left
        [:div.level-item
         [:div.buttons.has-addons
          ^{:key "prev"} [:button.button
                          {:disabled (= current-page 1)
                           :on-click (fn [_]
                                       (rf/dispatch [:amplify/query
                                                     queries/get-patients
                                                     {:limit  limit
                                                      :offset (* (- current-page 2) limit)
                                                      :filter {:organization_ids org-ids}
                                                      :query  query}
                                                     :backoffice/set-patients
                                                     :backoffice/noop]))}
                          "Prev"]
          ^{:key "next"} [:button.button
                          {:disabled (= current-page page-count)
                           :on-click (fn [_]
                                       (rf/dispatch [:amplify/query
                                                     queries/get-patients
                                                     {:limit  limit
                                                      :offset (* current-page limit)
                                                      :filter {:organization_ids org-ids}
                                                      :query  query}
                                                     :backoffice/set-patients
                                                     :backoffice/noop]))}
                          "Next"]]]
        [:div.level-item
         [:div.buttons.has-addons
          (doall
           (for [i    (range 1 (inc page-count))
                 :let [v (if (or (= i 1)
                                 (= i page-count)
                                 (< left i right))
                           ;; number button
                           ^{:key i} [:button.button
                                      {:class    (when (= i current-page) "is-active")
                                       :on-click (fn [_]
                                                   (rf/dispatch [:amplify/query
                                                                 queries/get-patients
                                                                 {:limit  limit
                                                                  :offset (* (dec i) limit)
                                                                  :filter {:organization_ids org-ids}
                                                                  :query  query}
                                                                 :backoffice/set-patients
                                                                 :backoffice/noop]))}
                                      i]
                           ;; elilipsis
                           ^{:key (str "ellipsis-" i)} [:button.button {:disabled true} "..."])]
                 :when (or (= i 1)
                           (= i page-count)
                           (<= left i right))]
             v))]]]
       [:div.level-right
        [:div.level-item
         [:span.has-text-grey (tr :ui.label/patient-count total)]]]])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Panel

(defn panel
  "The patients panel"
  []
  (let [organization (rf/subscribe [:backoffice/organization])
        patients     (rf/subscribe [:backoffice/patients])
        limit        (:limit @patients)
        query        (:query @patients)
        state        (reagent/atom {:organization @organization})]
    (rf/dispatch [:amplify/query
                  queries/get-patients
                  {:limit  limit
                   :offset 0
                   :filter {:organization_ids [(str (:organization/id @organization))]}
                   :query  query}
                  :backoffice/set-patients
                  :backoffice/noop])
    (fn []
      (let [org      (rf/subscribe [:backoffice/organization])
            patients (rf/subscribe [:backoffice/patients])
            limit    (:limit @patients)
            query    (:query @patients)
            loading? (rf/subscribe [:backoffice/gql-request-in-progress?])]
        (when (not= (get-in @state [:organization :organization/id]) (:organization/id @org))
          (rf/dispatch [:amplify/query
                        queries/get-patients
                        {:limit  limit
                         :offset 0
                         :filter {:organization_ids [(str (:organization/id @org))]}
                         :query  query}
                        :backoffice/set-patients
                        :backoffice/noop])
          (swap! state assoc :organization @org))
        [:section.section.is-main-section
         ;; lists
         [:div.card.has-table.has-mobile-sort-spaced
          ;; header
          [:div.card-header
           [:p.card-header-title
            [:span.icon
             [:i.mdi.mdi-account-multiple]]
            (tr :ui.label/patients)]
           [:button.button.is-small
            {:type     :button
             :disabled @loading?
             :on-click (fn [_]
                         (let [limit (:limit @patients)
                               ;; org-ids (mapv str (get-in @patients [:filter :organization-ids]))
                               query (:query @patients)]
                           (rf/dispatch [:amplify/query
                                         queries/get-patients
                                         {:limit  limit
                                          :offset 0
                                          :filter {:organization_ids [(str (:organization/id @org))]}
                                          :query  query}
                                         :backoffice/set-patients
                                         :backoffice/noop])))}
            [:span.icon
             [:i.mdi.mdi-refresh.default]]
            [:span (tr :ui.label/refresh)]]]
          ;; toolbar
          [:div.notification.is-card-toolbar
           [:div.level
            [:div.level-right
             [search-field (:query @patients)]]]]
          ;; patients
          [:div.card-content
           [patients/table @patients]]
          ;; table navigation
          [:div.notification
           [pagination @patients]]]]))))
